import Tooltip from './Tooltip';
import TooltipTable from './TooltipTable';
import { kapschFaultTreeEventName, kapschFaultTreeDescriptions } from 'utils/kapschFaultTree';
import { IAssetValue } from 'types/apiTypes';
import { MessageCircleQuestionMarkIcon } from 'lucide-react';

interface IAssetStatusTooltipProps {
  statusAttribute?: IAssetValue;
  title: string;
}

function AssetStatusTooltip({ title, statusAttribute }: IAssetStatusTooltipProps) {
  if (!statusAttribute) {
    return null;
  }
  const attributeValue = <>{statusAttribute.value}</>;

  if (!['ERROR TECHNICAL', 'FATAL ERROR'].includes(statusAttribute.value)) {
    return attributeValue;
  }
  if (!statusAttribute.additionalInformation || statusAttribute.additionalInformation === '') {
    return attributeValue;
  }
  const additionalInformation = statusAttribute.additionalInformation
    ?.split('|')
    .map((v) => v.trim());
  if (additionalInformation.length < 2) {
    return attributeValue;
  }

  const errorId = parseInt(additionalInformation[0].split(':')[1], 10);
  const description = kapschFaultTreeDescriptions[kapschFaultTreeEventName[errorId]];
  return (
    <Tooltip>
      <Tooltip.Trigger>
        {attributeValue}
        <MessageCircleQuestionMarkIcon className="-mt-1 ml-2 inline-block" size={16} />
        <Tooltip.Content>
          <TooltipTable title={title}>
            <TooltipTable.Row label="severity:" value={statusAttribute.value} />
            <TooltipTable.Row label="eventId:" value={errorId} />
            <TooltipTable.Row label="eventName:" value={additionalInformation[1].split(':')[1]} />
            <TooltipTable.Row
              maxContentWidth={250}
              label="description:"
              value={description ?? '-'}
            />
          </TooltipTable>
        </Tooltip.Content>
      </Tooltip.Trigger>
    </Tooltip>
  );
}

export default AssetStatusTooltip;
